import { Fragment } from 'react';
import './App.scss';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <Fragment>
      <AppRoutes />
    </Fragment>
  );
}

export default App;
